/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import CustomPaperWrapper from "../../Elements/CustomPaperWrapper";
import BroxelSmsForm from "../../Forms/BroxelSmsForm";

import BroxelHorizontalEng from "../../../Images/broxel-horizontal-eng.png";
import BroxelHorzontalSpa from "../../../Images/broxel-horizontal-spa.png";
import BroxelVerticalEng from "../../../Images/broxel-vertical-eng.png";
import BroxelVerticalSpa from "../../../Images/broxel-vertical-spa.png";

const styles = (theme) => ({
  paper: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  img: {
    // minHeight: "100%",
    // maxHeight: isMobile ? "75vh" : "75vh",
    minHeight: "50vh",
    height: "auto",
    // maxHeight: isMobile ? "60vh" : "70vh",
    width: "100%",
    borderRadius: 8,
    overflowY: "hidden",
    objectFit: "stretch",
  },
  spinnerContainer: {
    height: 200,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});

const useStyles = makeStyles(styles);

function BroxelSendSmsSection(props) {
  const classes = useStyles();
  const { lang } = props;

  useEffect(() => {
    window.scrollTo(0, 1000000000);
  }, []);

  const icon = <PaymentOutlinedIcon fontSize="large" />;

  let poster = BroxelHorizontalEng;

  if (lang === "es") poster = BroxelHorzontalSpa;

  let verticlePoster = BroxelVerticalEng;

  if (lang === "es") verticlePoster = BroxelVerticalSpa;

  return (
    <CustomPaperWrapper title="BROXEL" icon={icon}>
      <Paper className={classes.paper} elevation={6}>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="center"
          //   alignItems="center"
        >
          <Grid item xs={5}>
            <BroxelSmsForm />
          </Grid>
          <Hidden smDown>
            <Grid item xs={7}>
              <img src={poster} alt="announcement" className={classes.img} />
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid item xs={7}>
              <img
                src={verticlePoster}
                alt="announcement"
                className={classes.img}
              />
            </Grid>
          </Hidden>
        </Grid>
      </Paper>
    </CustomPaperWrapper>
  );
}

BroxelSendSmsSection.propTypes = {
  lang: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    lang: state.applicationState.lang,
  };
}

export default connect(mapStateToProps, {})(BroxelSendSmsSection);
